// UI
import { DialogWrapper } from "@/components/dialogs/DialogWrapper"

// Icons
import { XIcon } from "@/lib/icons"

// Translations
import { useTrans } from "@/lib/i18n"

/**
 * ProjectTypeBonds
 * @returns
 */
export function ProjectTypeBonds({ onClose }: { onClose: () => void }) {
	const t = useTrans("dashboard")

	return (
		<DialogWrapper>
			<div className="flex items-start justify-between rounded-t border-b p-5 dark:border-gray-600">
				<h3 className="text-xl font-semibold text-gray-900 lg:text-2xl dark:text-white">
					{t("dashboard:project_type_dialog.bonds.title")}
				</h3>
				<button
					onClick={() => onClose()}
					type="button"
					className="ml-auto inline-flex items-center rounded-lg bg-transparent p-1.5 text-sm text-gray-400 hover:bg-gray-200 hover:text-gray-900 dark:hover:bg-gray-600 dark:hover:text-white"
					data-modal-toggle="default-modal"
				>
					<XIcon width={24} className="text-2xl text-gray-400" />
				</button>
			</div>

			<div className="space-y-6 p-6">
				<p className="text-base leading-relaxed text-gray-500 dark:text-gray-400">
					{t("dashboard:project_type_dialog.bonds.intro")}
				</p>
				<ul className="ml-0 list-disc whitespace-pre-wrap text-gray-500">
					<li>
						{t(
							"dashboard:project_type_dialog.bonds.bullet_solar_shares",
						)}
					</li>
					<li>
						{t(
							"dashboard:project_type_dialog.bonds.bullet_portfolio",
						)}
					</li>
					<li>
						{t("dashboard:project_type_dialog.bonds.bullet_pro")}
					</li>
				</ul>
			</div>
		</DialogWrapper>
	)
}
